export default __webpack_public_path__ + "static/media/MixiiIsrael.6769796a.svg";